import Tooltip from 'components/tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { Row } from '@tanstack/react-table';
import { CustomDataField } from 'models/CustomDataField';
import useDeleteCustomFieldModal from '../../delete/useDeleteCustomFieldModal';
import { RemoveIcon, ActionsCellContainer } from './ActionsCell.styles';

const ActionsCell = ({ row }: { row: Row<CustomDataField> }) => {
  const { t } = useTranslation();
  const { openDeleteConfirmationModal } = useDeleteCustomFieldModal(
    row.original,
  );

  return (
    <ActionsCellContainer>
      <Tooltip id="row-delete-custom-field-button" text={t('common.delete')}>
        <RemoveIcon
          data-testid="delete-custom-field-button"
          aria-label={t('common.delete')}
          onClick={openDeleteConfirmationModal}
        />
      </Tooltip>
    </ActionsCellContainer>
  );
};

export default ActionsCell;
